import { usePopStore } from '@/stores/pop';

/**
 * 全域 loading 計數。
 *
 * 由多個 axios instance 共用，因此放在獨立模組而非各自的 instance 檔案裡
 * —— 兩個 instance 各持一份計數會讓 spinner 提早消失或卡住不關。
 */
let loadingCount = 0;

export function startLoading(): void {
  loadingCount++;
  usePopStore().loadingStatus = true;
}

export function stopLoading(): void {
  loadingCount--;

  if (loadingCount <= 0) {
    loadingCount = 0;
    usePopStore().loadingStatus = false;
  }
}
